const verification_record = {
    not_found: '検証レコードが見つかりません。',
    permission_denied: '許可が拒否されましたので、再認証してください。',
    not_supported_for_google_one_tap: 'この API は Google One Tap をサポートしていません。',
};
export default Object.freeze(verification_record);
